import ActionsForm from '@/shared/mixins/actionsForm'
import { loading, toast } from '@/shared/utils/UIHelper'
// import Tools from '@/components/tools/Tools.js'

import RestrictionAlert from '@/components//UI/restrictionAlert/restrictionAlert.vue'
import AssociateRepository from '@/shared/http/repositories/business/associate.js'
import OriginRepository from '@/shared/http/repositories/configurations/origin.js'
import PersonRepository from '@/shared/http/repositories/configurations/person.js'
import BoardRepositoryV2 from '@/shared/http/repositories/crm/board_v2.js'

import NewLeadData from '@/shared/models/crm/newLeadmodel.js'
import NewLeadForm from './newlead-form.js'

export default {
  name: 'ModalNewLead',
  mixins: [ActionsForm],
  props: {
    board: {
      type: Object,
      default: null
    },
    boardColumns: {
      type: Array,
      default: null
    }
  },
  data () {
    return {
      personDocument: null,
      personId: null,
      alreadyPerson: false,
      filledDocument: false,
      data: NewLeadData,
      form: NewLeadForm,
      nameNotPerson: '',
      buttonDisabled: false,
      searchingByName: false,
      newLeadName:
        this.board.tipoBoard === 'AJUIZAMENTO'
          ? 'Novo Processo'
          : 'Nova Oportunidade',
      isOportunidadeAssociado: this.board.isOportunidadeAssociado === true,
      associateName: '',
      naoDesejaInformarDocumento: false,
      pageLimit: 12,
      pageIndex: 0,
      errorTypes: {
        'alreadyHasPhone': ['could not execute statement; SQL']
      },
      errorTypeToUI: {
        'alreadyHasPhone': 'Não é possível criar a oportunidade. O telefone informado já está cadastrado para outro cooperado/não cooperado neste ou em algum quadro já existente. Utilize o cadastro existente ou informe outro telefone.'
      }
    }
  },
  components: {
    RestrictionAlert
  },
  created () {
    this.onGetAllOrigin()
  },
  mounted () {
    this.$refs['modal-newlead'].show()
  },
  watch: {
    naoDesejaInformarDocumento (newValue) {
      if (newValue) {
        this.form.documento.document = null
        toast.info(
          'Você optou por não informar o documento, para prosseguir com o registro do check-in sem o CPF/CNPJ insira o nome, celular ou telefone.'
        )
      }

      this.form.documento.required = !newValue
    }
  },
  computed: {
    boardColumnId () {
      let result = null
      if (this.boardColumns && this.boardColumns.length > 0) {
        let boardColumn = this.boardColumns.find(x => x.posicao === 0)
        if (boardColumn) {
          result = boardColumn.id
        }
      }
      return result
    }
  },
  methods: {
    onLoad () {},
    hideModal () {
      this.$refs['modal-newlead'].hide()
      this.$emit('closeModal')
    },
    async onCreate () {
      this.buttonDisabled = true

      try {
        if (this.alreadyPerson) {
          const data = this.createDataAlreadyPerson()
          await BoardRepositoryV2.Card_Create(
            this.board.id,
            data.boardColumnId,
            data
          )
            .then(response => {
              this.hideModal()
              toast.success(this.$lang.Common.Alerts.Success, this.newLeadName)
              this.$emit('Back')
            })
            .catch(err => {
              if (err.data.errors[0]) {
                toast.warning(
                  err.data.errors[0].message,
                  'Não é possível criar a ' + this.newLeadName
                )
              } else {
                console.error(err)
                this.onException(err)
              }
            })
        } else {
          const data = this.createDataNotAlreadyPerson()

          if (
            !data.pessoa ||
            (!data.pessoa.document &&
              (!data.pessoa.telefone || data.pessoa.telefone.length === 0))
          ) {
            toast.error(
              'Informe ao menos um telefone/celular para gerar a oportunidade'
            )
            return
          }

          await BoardRepositoryV2.Card_CreateCardAndPerson(
            this.board.id,
            data.boardColumnId,
            data
          )
            .then(response => {
              this.hideModal()
              toast.success(this.$lang.Common.Alerts.Success, this.newLeadName)
              this.$emit('Back')
            })
            .catch(err => {
              if (err.data.errors[0]) {
                let friendlyErrorMessage = this.returnFriendlyErrorMessage(err.data.errors[0].message)
                toast.warning(
                  friendlyErrorMessage,
                  'Não é possível criar oportunidade.'
                )
              } else {
                console.error(err)
                this.onException(err)
              }
            })
        }
      } catch (error) {
        console.error(error)
      } finally {
        this.buttonDisabled = false
      }
    },
    createDataAlreadyPerson () {
      return {
        ...this.createData(),
        pessoaId: this.personId
      }
    },
    createDataNotAlreadyPerson () {
      const telefone = []
      if (this.form.telefone.value) {
        telefone.push({
          telefone: this.form.telefone.value,
          tipoContato: 'COMERCIAL'
        })
      }
      if (this.form.celular.value) {
        telefone.push({
          telefone: this.form.celular.value,
          tipoContato: 'CELULAR'
        })
      }

      return {
        ...this.createData(),
        pessoa: {
          nome: this.form.name.selected
            ? this.form.name.selected.value
            : this.form.name.value,
          email: this.form.email.value,
          document: this.form.documento.value
            ? this.form.documento.value.toString().replace(/[^\d]+/g, '')
            : null,
          telefone: telefone
        }
      }
    },
    createData () {
      let cardData = {
        boardColumnId: this.boardColumnId,
        motivoPerdaId: null,
        posicao: 0,
        situacao: 'ATIVO',
        countReativado: 0,
        dataCriacao: new Date().toISOString(),
        dataInicioSituacao: new Date().toISOString(),
        dataReativacao: null,
        origemLeadId: this.form.leadOriginID.value
      }
      return cardData
    },
    manageNameComponent (search) {
      if (search !== '') {
        this.nameNotPerson = search
        return
      }

      if (!this.form.name.selected) {
        this.filledDocument = true
        this.form.name.value = this.nameNotPerson
        toast.info(
          'Não foi encontrado uma pessoa com este Nome.',
          this.newLeadName
        )
        // this.$refs.documento.focus()
      }
    },
    onLoadLeads (search) {
      this.manageNameComponent(search)
      if (this.form.name.selected && !search) {
        this.form.name.value = this.form.name.selected.text

        this.searchingByName = true
        this.onSearchPessoa(search.value)
        this.searchingByName = false
      } else if (typeof search === 'string') {
        PersonRepository.GetByName(search).then(response => {
          this.form.name.listOptions = response.data.content
            .filter(x => x.id != null)
            .map(x => ({ value: x.document, text: x.nome }))
        })
      }
    },
    onLoadLeadsAssociados (search) {
      this.manageNameComponent(search)
      if (this.form.name.selected && !search) {
        this.form.name.value = this.form.name.selected.text

        this.searchingByName = true
        this.onSearchAssociado(search.value)
        this.searchingByName = false
      } else if (typeof search === 'string') {
        AssociateRepository.GetByNomeAssociado(search).then(response => {
          this.form.name.listOptions = response.data.content
            .filter(x => x.id != null)
            .map(x => ({ value: x.pessoa.document, text: x.pessoa.nome }))
        })
      }
    },
    getPersonData (documentOnlyNumber) {
      PersonRepository.GetByDocument(documentOnlyNumber)
        .then(response => {
          let data = response.data.content

          if (data.length > 0) {
            let personId = data[0].id
            this.alreadyPerson = true
            this.personId = personId
            this.$nextTick(async () => {
              await this.setFormValues(response.data.content[0])
              this.$forceUpdate()
            })
          } else {
            this.alreadyPerson = false
            if (!this.form.name.value) {
              toast.info(
                'Não foi encontrado uma pessoa com este CPF.',
                this.newLeadName
              )
            }
          }
        })
        .catch(err => {
          console.error('err', err)
          this.onException(err)
        })
    },
    onSearchPessoa (document) {
      if (this.form.documento.value || this.form.name.selected) {
        if (this.form.documento.value) this.filledDocument = true
        this.personDocument = this.searchingByName
          ? this.form.name.selected.value
          : this.form.documento.value.replace(/[^\d]+/g, '')

        if (this.form.documento.value && this.form.name.value) return

        this.getPersonData(this.personDocument)
      } else {
        this.clearForms()
        toast.info(
          'Atenção! Você precisa informar um CPF ou CNPJ para localizar o contato.',
          this.newLeadName
        )
      }
    },
    onSearchAssociado (document) {
      if (this.form.documento.value || this.form.name.selected) {
        if (this.form.documento.value) this.filledDocument = true
        this.personDocument = this.searchingByName
          ? this.form.name.selected.value
          : this.form.documento.value.replace(/[^\d]+/g, '')

        if (this.form.documento.value && this.form.name.value) return

        this.getAssociateData(this.personDocument)
      } else {
        this.clearForms()
        toast.info(
          'Atenção! Você precisa informar um CPF ou CNPJ para localizar o contato.',
          this.newLeadName
        )
      }
    },
    clearForms () {
      this.alreadyPerson = false
      this.filledDocument = false
      this.form.documento.value = null
      this.form.name.value = null
      this.form.name.selected = null
      this.form.email.value = ''
      this.form.celular.value = ''
      this.form.telefone.value = ''
      this.form.leadOriginID.value = null
      this.dismissCountDown = 0
      this.personDocument = null
      this.form.name.listOptions = []
    },
    setFormValues (dataToForm) {
      this.form.documento.value = dataToForm.document
      this.form.name.selected = dataToForm.nome
      this.form.name.value = dataToForm.nome
      this.form.email.value = dataToForm.email
      for (let i in dataToForm.telefone) {
        if (dataToForm.telefone[i].tipoContato === 'CELULAR') {
          this.form.celular.value = dataToForm.telefone[i].telefone
        } else {
          this.form.telefone.value = dataToForm.telefone[i].telefone
        }
      }
    },
    setFormAssociadoValues (dataToForm) {
      this.form.documento.value = dataToForm.pessoa.document
      this.form.name.selected = dataToForm.pessoa.nome
      this.form.name.value = dataToForm.pessoa.nome
      this.form.email.value = dataToForm.pessoa.email
      for (let i in dataToForm.pessoa.telefone) {
        if (dataToForm.pessoa.telefone[i].tipoContato === 'CELULAR') {
          this.form.celular.value = dataToForm.pessoa.telefone[i].telefone
        } else {
          this.form.telefone.value = dataToForm.pessoa.telefone[i].telefone
        }
      }
    },
    onGetAllOrigin () {
      loading.push()
      OriginRepository.GetAllActive()
        .then(response => {
          if (this.board && this.board.tipoBoard) {
            let result = response.data.content
            let filteredResult = []
            // CHECK IF ORIGEM DOES NOT HAVE SPECIFIC TYPES || SPECIFIC TYPE MACHES THE BOARD
            result.forEach(el => {
              if (
                !el.tipoAcessoOrigem.length ||
                this.hasBoardType(el.tipoAcessoOrigem)
              ) {
                filteredResult.push(el)
              }
            })
            this.form.leadOriginID.options = filteredResult.map(x => ({
              value: x.id,
              text: x.nome
            }))
          } else {
            this.form.leadOriginID.options = this.onResultDropdown(
              response,
              null,
              f => f.nome
            )
          }
        })
        .catch(this.onException)
        .finally(() => {
          loading.pop()
        })
    },
    hasBoardType (originArray) {
      let boardType = this.board.tipoBoard
      return originArray.some(board => board === boardType)
    },
    getAssociateData (documentOnlyNumber) {
      var query = `document=${documentOnlyNumber.replace(/[^\d]+/g, '')}`
      AssociateRepository.Search(query, this.pageIndex)
        .then(response => {
          let data = response.data.content

          if (data.length > 0) {
            let personId = data[0].pessoa.id
            this.alreadyPerson = true
            this.personId = personId
            this.$nextTick(async () => {
              await this.setFormAssociadoValues(response.data.content[0])
              this.$forceUpdate()
            })
          } else {
            this.alreadyPerson = false
            if (!this.form.name.value) {
              toast.info(
                'Não foi encontrado uma pessoa com este CPF ou pertence a outra carteira.',
                this.newLeadName
              )
            }
          }
        })
        .catch(err => {
          console.error('err', err)
          this.onException(err)
        })
    },
    returnFriendlyErrorMessage (initErrorMessage) {
      let friendlyError = ''
      for (let [k, v] of Object.entries(this.errorTypes)) {
        if (initErrorMessage.includes(v)) {
          for (let [k1, v1] of Object.entries(this.errorTypeToUI)) {
            if (k1 === k) {
              friendlyError = v1
            }
          }
        }
      }
      if (friendlyError.length >= 1) {
        return friendlyError
      } else {
        return initErrorMessage
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/views/private/crm/board/modal/new/newlead.js